import type { AIDataCenter } from './types';

// Data from Epoch AI GPU Clusters dataset
// https://epoch.ai/data/gpu-clusters
// Licensed under Creative Commons Attribution
// Filtered for clusters with >1000 GPUs, Existing/Planned status, Confirmed/Likely certainty

export const AI_DATA_CENTERS: AIDataCenter[] = [
  {
    id: 'dc-1',
    name: 'OpenAI/Microsoft Mt Pleasant, Wisconsin Phase 2',
    owner: 'OpenAI,Microsoft',
    country: 'United States of America',
    lat: 42.6978,
    lon: -87.8912,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 700000,
  },
  {
    id: 'dc-2',
    name: 'Fluidstack France Gigawatt Campus',
    owner: 'Unknown',
    country: 'France',
    lat: 46.2276,
    lon: 2.7137,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 500000,
    powerMW: 1000,
    sector: 'Public/Private',
  },
  {
    id: 'dc-5',
    name: 'Meta Prometheus New Albany',
    owner: 'Meta AI',
    country: 'United States of America',
    lat: 40.0812,
    lon: -82.8085,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 500000,
    powerMW: 1281.3,
    sector: 'Private',
  },
  {
    id: 'dc-3',
    name: 'Reliance Industries Supercomputer',
    owner: 'Reliance Industries',
    country: 'India',
    lat: 20.5937,
    lon: 79.4629,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 450000,
    powerMW: 1000,
    sector: 'Private',
  },
  {
    id: 'dc-22',
    name: 'Project Rainier',
    owner: 'Amazon',
    country: 'United States of America',
    lat: 37.9704,
    lon: -97.8378,
    status: 'planned',
    chipType: 'Amazon Trainium2',
    chipCount: 400000,
    powerMW: 350,
    sector: 'Private',
  },
  {
    id: 'dc-4',
    name: 'xAI Colossus 2 Memphis Phase 2',
    owner: 'xAI',
    country: 'United States of America',
    lat: 35.1175,
    lon: -89.7439,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 330000,
  },
  {
    id: 'dc-6',
    name: 'OpenAI/Microsoft Atlanta',
    owner: 'OpenAI,Microsoft',
    country: 'United States of America',
    lat: 33.7490,
    lon: -84.3880,
    status: 'planned',
    chipType: 'NVIDIA B200',
    chipCount: 300000,
  },
  {
    id: 'dc-17',
    name: 'OpenAI Stargate Abilene Oracle OCI Supercluster Phase 2',
    owner: 'Oracle',
    country: 'United States of America',
    lat: 32.4789,
    lon: -99.6669,
    status: 'planned',
    chipType: 'NVIDIA GB300 (Blackwell Ultra)',
    chipCount: 200001,
  },
  {
    id: 'dc-16',
    name: 'xAI Colossus Memphis Phase 3',
    owner: 'xAI',
    country: 'United States of America',
    lat: 34.8704,
    lon: -90.0605,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 200000,
  },
  {
    id: 'dc-313',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 27.5118,
    lon: 111.2018,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 200000,
    powerMW: 80,
    sector: 'Public',
  },
  {
    id: 'dc-7',
    name: 'Applied Digital Ellendale Possible Phase 3',
    owner: 'Applied Digital',
    country: 'United States of America',
    lat: 46.0022,
    lon: -98.5267,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 180000,
  },
  {
    id: 'dc-8',
    name: 'Nebius New Jersey',
    owner: 'Nebius AI',
    country: 'United States of America',
    lat: 40.0583,
    lon: -74.4057,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 150000,
    powerMW: 300,
    sector: 'Private',
  },
  {
    id: 'dc-9',
    name: 'Sesterce Grand Est France B',
    owner: 'Sesterce',
    country: 'France',
    lat: 46.7005,
    lon: 1.6976,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 150000,
  },
  {
    id: 'dc-10',
    name: 'Sesterce Grand Est France A',
    owner: 'Sesterce',
    country: 'France',
    lat: 45.331,
    lon: 2.2921,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 150000,
  },
  {
    id: 'dc-11',
    name: 'OpenAI/Microsoft Mt Pleasant, Wisconsin Phase 1',
    owner: 'OpenAI,Microsoft',
    country: 'United States of America',
    lat: 42.6978,
    lon: -87.8912,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 150000,
  },
  {
    id: 'dc-20',
    name: 'xAI Colossus Memphis Phase 2',
    owner: 'xAI',
    country: 'United States of America',
    lat: 35.3203,
    lon: -90.091,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 150000,
    powerMW: 280.3,
    sector: 'Private',
  },
  {
    id: 'dc-13',
    name: 'Oracle OCI Supercluster B200s',
    owner: 'Oracle',
    country: 'United States of America',
    lat: 38.7323,
    lon: -96.1529,
    status: 'planned',
    chipType: 'NVIDIA B200',
    chipCount: 131072,
    powerMW: 262.4,
    sector: 'Private',
  },
  {
    id: 'dc-12',
    name: 'Sesterce Southern France 250MW',
    owner: 'Sesterce',
    country: 'France',
    lat: 47.1003,
    lon: 2.8833,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 120000,
  },
  {
    id: 'dc-28',
    name: 'Tesla Cortex Phase 3',
    owner: 'Tesla',
    country: 'United States of America',
    lat: 30.4475,
    lon: -97.8798,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 120000,
    powerMW: 140.1,
    sector: 'Private',
  },
  {
    id: 'dc-14',
    name: 'Applied Digital CoreWeave Ellendale Phase 2',
    owner: 'Applied Digital',
    country: 'United States of America',
    lat: 46.0022,
    lon: -98.5267,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 110000,
  },
  {
    id: 'dc-15',
    name: 'xAI Colossus 2 Memphis Phase 1',
    owner: 'xAI',
    country: 'United States of America',
    lat: 35.263,
    lon: -89.907,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 110000,
    powerMW: 264.3,
    sector: 'Private',
  },
  {
    id: 'dc-18',
    name: 'OpenAI Stargate Abilene Oracle OCI Supercluster Phase 1',
    owner: 'Oracle',
    country: 'United States of America',
    lat: 32.4067,
    lon: -99.6511,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 100000,
  },
  {
    id: 'dc-19',
    name: 'CoreWeave Denton GB200s OpenAI/Microsoft',
    owner: 'CoreWeave',
    country: 'United States of America',
    lat: 33.2148,
    lon: -97.1331,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 100000,
  },
  {
    id: 'dc-27',
    name: 'xAI Colossus Memphis Phase 1',
    owner: 'xAI',
    country: 'United States of America',
    lat: 35.1221,
    lon: -90.1423,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 100000,
    powerMW: 150,
    sector: 'Private',
  },
  {
    id: 'dc-29',
    name: 'Meta 100k',
    owner: 'Meta AI',
    country: 'United States of America',
    lat: 35.6402,
    lon: -98.2244,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 100000,
    powerMW: 142.7,
    sector: 'Private',
  },
  {
    id: 'dc-30',
    name: 'OpenAI/Microsoft Goodyear Arizona',
    owner: 'Microsoft,OpenAI',
    country: 'United States of America',
    lat: 33.4308,
    lon: -112.5925,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 100000,
  },
  {
    id: 'dc-78',
    name: 'Stargate UAE Phase 1',
    owner: 'Stargate (OpenAI)',
    country: 'United Arab Emirates',
    lat: 24.2968,
    lon: 54.5174,
    status: 'planned',
    chipType: 'NVIDIA GB300 (Blackwell Ultra)',
    chipCount: 100000,
  },
  {
    id: 'dc-133',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 33.5959,
    lon: 105.2519,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 100000,
    sector: 'Public',
  },
  {
    id: 'dc-32',
    name: 'Oracle OCI Supercluster H200s',
    owner: 'Oracle',
    country: 'United States of America',
    lat: 39.7934,
    lon: -97.6057,
    status: 'existing',
    chipType: 'NVIDIA H200 SXM',
    chipCount: 65536,
  },
  {
    id: 'dc-166',
    name: 'Argonne NL Aurora',
    owner: 'US Department of Energy',
    country: 'United States of America',
    lat: 49.2024,
    lon: -99.5319,
    status: 'existing',
    chipType: 'Intel Data Center GPU Max 1550',
    chipCount: 63744,
    powerMW: 60,
    sector: 'Public',
  },
  {
    id: 'dc-21',
    name: 'SK Group AWS Uslan Phase 2',
    owner: 'SK Telecom,Amazon',
    country: 'Korea (Republic of)',
    lat: 35.9078,
    lon: 128.2669,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 60000,
    powerMW: 103,
    sector: 'Private',
  },
  {
    id: 'dc-33',
    name: 'Nebius Finland Phase 2',
    owner: 'Nebius AI',
    country: 'Finland',
    lat: 61.9241,
    lon: 26.2482,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 60000,
    powerMW: 84.1,
    sector: 'Private',
  },
  {
    id: 'dc-34',
    name: 'G42 Microsoft 100Mw UAE Cluster',
    owner: 'G42,Microsoft',
    country: 'United Arab Emirates',
    lat: 23.4241,
    lon: 54.3478,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 55000,
  },
  {
    id: 'dc-36',
    name: 'Tesla Cortex Phase 1',
    owner: 'Tesla',
    country: 'United States of America',
    lat: 30.4364,
    lon: -97.649,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 50000,
    powerMW: 71.3,
    sector: 'Private',
  },
  {
    id: 'dc-37',
    name: 'Tesla Cortex Phase 2',
    owner: 'Tesla',
    country: 'United States of America',
    lat: 30.4715,
    lon: -97.8794,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 50000,
    powerMW: 70.1,
    sector: 'Private',
  },
  {
    id: 'dc-311',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 37.2583,
    lon: 93.5869,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 50000,
    powerMW: 20,
    sector: 'Public',
  },
  {
    id: 'dc-23',
    name: 'Applied Digital CoreWeave Ellendale Phase 1',
    owner: 'Applied Digital',
    country: 'United States of America',
    lat: 34.8244,
    lon: -94.6564,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 45000,
  },
  {
    id: 'dc-24',
    name: 'Nscale Loughton',
    owner: 'Unknown',
    country: 'United Kingdom of Great Britain and Northern Ireland',
    lat: 55.3781,
    lon: -2.936,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 45000,
    powerMW: 90,
    sector: 'Private',
  },
  {
    id: 'dc-38',
    name: 'Lawrence Livermore NL El Capitan Phase 2',
    owner: 'US Department of Energy',
    country: 'United States of America',
    lat: 37.9127,
    lon: -121.9141,
    status: 'existing',
    chipType: 'AMD Instinct MI300A',
    chipCount: 44544,
    powerMW: 35,
    sector: 'Public',
  },
  {
    id: 'dc-39',
    name: 'CoreWeave H200s',
    owner: 'CoreWeave',
    country: 'United States of America',
    lat: 39.4685,
    lon: -92.8785,
    status: 'existing',
    chipType: 'NVIDIA H200 SXM',
    chipCount: 42000,
    powerMW: 59.9,
    sector: 'Private',
  },
  {
    id: 'dc-25',
    name: 'CoreWeave Muskogee',
    owner: 'CoreWeave',
    country: 'United States of America',
    lat: 39.6652,
    lon: -94.901,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 40000,
  },
  {
    id: 'dc-26',
    name: 'Sesterce Valence',
    owner: 'Sesterce',
    country: 'France',
    lat: 46.0019,
    lon: 0.9334,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 40000,
    powerMW: 96.1,
    sector: 'Private',
  },
  {
    id: 'dc-97',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 35.0558,
    lon: 105.4605,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 40000,
    sector: 'Public/Private',
  },
  {
    id: 'dc-224',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 34.2078,
    lon: 98.95,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 40000,
    powerMW: 30,
    sector: 'Public',
  },
  {
    id: 'dc-272',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 41.3913,
    lon: 99.1285,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 40000,
    powerMW: 20,
    sector: 'Public',
  },
  {
    id: 'dc-305',
    name: 'Neevcloud planned GPUs',
    owner: 'NeevCloud',
    country: 'India',
    lat: 19.7878,
    lon: 80.228,
    status: 'planned',
    chipType: 'Unknown',
    chipCount: 40000,
    sector: 'Private',
  },
  {
    id: 'dc-85',
    name: 'Oak Ridge NL Frontier',
    owner: 'US Department of Energy',
    country: 'United States of America',
    lat: 35.9425,
    lon: -84.1017,
    status: 'existing',
    chipType: 'AMD Radeon Instinct MI250X',
    chipCount: 37632,
    powerMW: 40,
    sector: 'Public',
  },
  {
    id: 'dc-31',
    name: 'together.ai 36k GB200s',
    owner: 'Together',
    country: 'United States of America',
    lat: 36.4192,
    lon: -92.6864,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 36000,
    powerMW: 86.5,
    sector: 'Private',
  },
  {
    id: 'dc-71',
    name: 'Oracle OCI Supercluster A100s',
    owner: 'Oracle',
    country: 'United States of America',
    lat: 36.454,
    lon: -88.4407,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 32768,
  },
  {
    id: 'dc-101',
    name: 'Google Oklahoma TPU v4 Pods',
    owner: 'Google',
    country: 'United States of America',
    lat: 29.7527,
    lon: -100.3874,
    status: 'existing',
    chipType: 'Google TPU v4',
    chipCount: 32768,
    powerMW: 23.7,
    sector: 'Private',
  },
  {
    id: 'dc-42',
    name: 'Lambda Labs H100/H200',
    owner: 'Lambda Labs',
    country: 'United States of America',
    lat: 34.1911,
    lon: -92.8138,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 32000,
  },
  {
    id: 'dc-43',
    name: 'NVIDIA CoreWeave Eos-DFW Rumored Phase 2',
    owner: 'NVIDIA,CoreWeave',
    country: 'United States of America',
    lat: 41.3861,
    lon: -95.9005,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 32000,
    powerMW: 44.8,
    sector: 'Private',
  },
  {
    id: 'dc-81',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 36.7344,
    lon: 104.865,
    status: 'planned',
    chipType: 'Unknown',
    chipCount: 30000,
    powerMW: 40,
    sector: 'Public',
  },
  {
    id: 'dc-90',
    name: 'AWS EC2 Trn1',
    owner: 'Amazon',
    country: 'United States of America',
    lat: 36.3842,
    lon: -103.7821,
    status: 'existing',
    chipType: 'Amazon Trainium1',
    chipCount: 30000,
    sector: 'Private',
  },
  {
    id: 'dc-125',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 36.5799,
    lon: 106.1688,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 30000,
    powerMW: 20,
    sector: 'Private',
  },
  {
    id: 'dc-232',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 41.3126,
    lon: 101.9376,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 30000,
    sector: 'Public/Private',
  },
  {
    id: 'dc-306',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 32.8847,
    lon: 113.6372,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 30000,
  },
  {
    id: 'dc-126',
    name: 'Gemini 1.0 Ultra training cluster A',
    owner: 'Google',
    country: 'United States of America',
    lat: 38.4868,
    lon: -106.3214,
    status: 'existing',
    chipType: 'Google TPU v4',
    chipCount: 28672,
    powerMW: 20.2,
    sector: 'Private',
  },
  {
    id: 'dc-127',
    name: 'Gemini 1.0 Ultra training cluster B',
    owner: 'Google',
    country: 'United States of America',
    lat: 28.7403,
    lon: -88.7065,
    status: 'existing',
    chipType: 'Google TPU v4',
    chipCount: 28672,
    powerMW: 20.2,
    sector: 'Private',
  },
  {
    id: 'dc-44',
    name: 'Google A3 VMs',
    owner: 'Google',
    country: 'United States of America',
    lat: 33.643,
    lon: -98.6054,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 26000,
  },
  {
    id: 'dc-83',
    name: 'Microsoft GPT-4 cluster',
    owner: 'Microsoft,OpenAI',
    country: 'United States of America',
    lat: 42.0256,
    lon: -93.0338,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 25000,
    powerMW: 21.3,
    sector: 'Private',
  },
  {
    id: 'dc-312',
    name: 'Telangana Yotta Hyderbad AI City Cluster Phase 2',
    owner: 'Government of Telangana',
    country: 'India',
    lat: 18.9084,
    lon: 78.0856,
    status: 'planned',
    chipType: 'Unknown',
    chipCount: 25000,
    powerMW: 50,
    sector: 'Public',
  },
  {
    id: 'dc-45',
    name: 'Meta GenAI 2024b',
    owner: 'Meta AI',
    country: 'United States of America',
    lat: 37.7037,
    lon: -91.0531,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 24576,
    powerMW: 35.1,
    sector: 'Private',
  },
  {
    id: 'dc-46',
    name: 'Meta GenAI 2024a',
    owner: 'Meta AI',
    country: 'United States of America',
    lat: 39.9007,
    lon: -99.7267,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 24576,
    powerMW: 35.1,
    sector: 'Private',
  },
  {
    id: 'dc-47',
    name: 'Jupiter, Jülich',
    owner: 'EuroHPC JU,Julich Supercomputing Center',
    country: 'Germany',
    lat: 51.1657,
    lon: 10.9515,
    status: 'existing',
    chipType: 'NVIDIA GH200',
    chipCount: 23536,
    powerMW: 18,
    sector: 'Public',
  },
  {
    id: 'dc-48',
    name: 'Inflection AI Cluster',
    owner: 'Inflection AI',
    country: 'United States of America',
    lat: 32.1111,
    lon: -94.6091,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 22000,
    powerMW: 31,
    sector: 'Private',
  },
  {
    id: 'dc-172',
    name: 'Meta 2017 V100 Cluster',
    owner: 'Meta AI',
    country: 'United States of America',
    lat: 42.1034,
    lon: -83.6101,
    status: 'existing',
    chipType: 'NVIDIA Tesla V100 SXM2',
    chipCount: 22000,
  },
  {
    id: 'dc-35',
    name: 'Project Ceiba Phase 2',
    owner: 'Amazon,NVIDIA',
    country: 'United States of America',
    lat: 33.6201,
    lon: -96.1697,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 20736,
    powerMW: 49.8,
    sector: 'Private',
  },
  {
    id: 'dc-50',
    name: 'Andreessen Horowitz Oxygen',
    owner: 'Andreessen Horowitz',
    country: 'United States of America',
    lat: 35.4363,
    lon: -100.9583,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 20000,
  },
  {
    id: 'dc-51',
    name: 'AWS EC2 P5 UltraClusters',
    owner: 'Amazon',
    country: 'United States of America',
    lat: 34.6813,
    lon: -90.5469,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 20000,
    powerMW: 29,
    sector: 'Private',
  },
  {
    id: 'dc-52',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 35.8617,
    lon: 104.6954,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 20000,
    powerMW: 30,
    sector: 'Private',
  },
  {
    id: 'dc-74',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 36.3346,
    lon: 103.6793,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 20000,
    sector: 'Public/Private',
  },
  {
    id: 'dc-124',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 34.1764,
    lon: 103.3181,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 20000,
    sector: 'Public/Private',
  },
  {
    id: 'dc-137',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 38.5649,
    lon: 102.3026,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 20000,
    sector: 'Public/Private',
  },
  {
    id: 'dc-199',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 32.4145,
    lon: 101.3029,
    status: 'planned',
    chipType: 'Unknown',
    chipCount: 20000,
    sector: 'Public',
  },
  {
    id: 'dc-243',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 38.7707,
    lon: 109.7836,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 20000,
    powerMW: 20,
    sector: 'Public',
  },
  {
    id: 'dc-84',
    name: 'Aramco Groq Inference Cluster',
    owner: 'Saudi Aramco',
    country: 'Saudi Arabia',
    lat: 24.3588,
    lon: 44.5631,
    status: 'existing',
    chipType: 'GroqChip LPU v1',
    chipCount: 19725,
    powerMW: 8.5,
    sector: 'Private',
  },
  {
    id: 'dc-170',
    name: 'HUMAIN Saudi Arabia/NVIDIA Phase 1',
    owner: 'Humain',
    country: 'Saudi Arabia',
    lat: 24.7586,
    lon: 45.7488,
    status: 'planned',
    chipType: 'NVIDIA GB300 (Blackwell Ultra)',
    chipCount: 18000,
    powerMW: 50.5,
    sector: 'Public/Private',
  },
  {
    id: 'dc-180',
    name: 'Lawrence Livermore NL Sierra',
    owner: 'US Department of Energy',
    country: 'United States of America',
    lat: 37.9088,
    lon: -121.6068,
    status: 'existing',
    chipType: 'NVIDIA V100',
    chipCount: 17280,
    powerMW: 11.5,
    sector: 'Public',
  },
  {
    id: 'dc-49',
    name: 'Oracle OCI MI300x',
    owner: 'Oracle',
    country: 'United States of America',
    lat: 41.6801,
    lon: -93.0629,
    status: 'existing',
    chipType: 'AMD Instinct MI300X',
    chipCount: 16384,
    powerMW: 25,
    sector: 'Private',
  },
  {
    id: 'dc-53',
    name: 'Yotta Shakti Cloud D1',
    owner: 'Yotta Data Services',
    country: 'India',
    lat: 21.0666,
    lon: 78.4468,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 16384,
    powerMW: 23,
    sector: 'Private',
  },
  {
    id: 'dc-54',
    name: 'Yotta Shakti Cloud NM1 Phase 2',
    owner: 'Yotta Data Services',
    country: 'India',
    lat: 19.6971,
    lon: 79.0413,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 16384,
    powerMW: 23,
    sector: 'Private',
  },
  {
    id: 'dc-55',
    name: 'NexGen Cloud Hyperstack AQ Compute Supercomputer',
    owner: 'NexGen Cloud',
    country: 'Norway',
    lat: 60.472,
    lon: 8.9689,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 16384,
    powerMW: 23.4,
    sector: 'Private',
  },
  {
    id: 'dc-56',
    name: 'Oracle OCI Supercluster H100s',
    owner: 'Oracle',
    country: 'United States of America',
    lat: 42.5411,
    lon: -97.9707,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 16384,
  },
  {
    id: 'dc-94',
    name: 'Meta Research SuperCluster (RSC-1) Phase 2',
    owner: 'Meta AI',
    country: 'United States of America',
    lat: 37.6547,
    lon: -78.5712,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 16000,
    powerMW: 13.3,
    sector: 'Private',
  },
  {
    id: 'dc-40',
    name: 'YTL AI Johor',
    owner: 'YTL Power',
    country: 'Malaysia',
    lat: 4.2105,
    lon: 102.4758,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 15428,
    powerMW: 37.1,
    sector: 'Private',
  },
  {
    id: 'dc-58',
    name: 'G42 Microsoft 30Mw UAE Cluster A',
    owner: 'G42,Microsoft',
    country: 'United Arab Emirates',
    lat: 23.897,
    lon: 53.3317,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 15000,
    powerMW: 30,
    sector: 'Public/Private',
  },
  {
    id: 'dc-59',
    name: 'G42 Microsoft 30Mw UAE Cluster B',
    owner: 'G42,Microsoft',
    country: 'United Arab Emirates',
    lat: 22.5275,
    lon: 53.9262,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 15000,
    powerMW: 30,
    sector: 'Public/Private',
  },
  {
    id: 'dc-61',
    name: 'Microsoft Azure Eagle',
    owner: 'Microsoft',
    country: 'United States of America',
    lat: 31.3581,
    lon: -97.7992,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 14400,
    powerMW: 20.9,
    sector: 'Private',
  },
  {
    id: 'dc-140',
    name: 'Eni HPC6',
    owner: 'Eni',
    country: 'Italy',
    lat: 40.9753,
    lon: 12.6458,
    status: 'existing',
    chipType: 'AMD Radeon Instinct MI250X',
    chipCount: 13888,
    powerMW: 14.2,
    sector: 'Private',
  },
  {
    id: 'dc-104',
    name: 'EuroHPC Leonardo',
    owner: 'EuroHPC JU',
    country: 'Italy',
    lat: 42.3448,
    lon: 12.0513,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 13824,
    powerMW: 12.6,
    sector: 'Public',
  },
  {
    id: 'dc-105',
    name: 'Amazon Titan training cluster',
    owner: 'Amazon',
    country: 'United States of America',
    lat: 41.2921,
    lon: -103.7847,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 13760,
    powerMW: 11.4,
    sector: 'Private',
  },
  {
    id: 'dc-66',
    name: 'xAI Fulton Georgia',
    owner: 'xAI',
    country: 'United States of America',
    lat: 31.4395,
    lon: -92.113,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 12112,
  },
  {
    id: 'dc-146',
    name: 'EuroHPC LUMI',
    owner: 'EuroHPC JU',
    country: 'Finland',
    lat: 61.0275,
    lon: 25.8266,
    status: 'existing',
    chipType: 'AMD Radeon Instinct MI250X',
    chipCount: 11912,
    powerMW: 12.1,
    sector: 'Public',
  },
  {
    id: 'dc-68',
    name: 'Microsoft Azure MLPerf 3.1 Submission',
    owner: 'Microsoft',
    country: 'United States of America',
    lat: 43.8854,
    lon: -94.5147,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 10752,
    powerMW: 15.6,
    sector: 'Private',
  },
  {
    id: 'dc-69',
    name: 'NVIDIA CoreWeave Eos-DFW Phase 1',
    owner: 'NVIDIA,CoreWeave',
    country: 'United States of America',
    lat: 32.768,
    lon: -101.3457,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 10752,
    powerMW: 15.6,
    sector: 'Private',
  },
  {
    id: 'dc-70',
    name: 'Alps Supercomputer Phase 2',
    owner: 'ETH Domain',
    country: 'Switzerland',
    lat: 46.8182,
    lon: 8.7275,
    status: 'existing',
    chipType: 'NVIDIA GH200',
    chipCount: 10752,
  },
  {
    id: 'dc-62',
    name: 'TensorWave MI300X Cluster 2',
    owner: 'TensorWave',
    country: 'United States of America',
    lat: 39.9992,
    lon: -90.1247,
    status: 'planned',
    chipType: 'AMD Instinct MI300X',
    chipCount: 10000,
    powerMW: 15,
    sector: 'Private',
  },
  {
    id: 'dc-63',
    name: 'TensorWave MI300X Cluster 1 Phase 2',
    owner: 'TensorWave',
    country: 'United States of America',
    lat: 38.7725,
    lon: -101.9914,
    status: 'planned',
    chipType: 'AMD Instinct MI300X',
    chipCount: 10000,
    powerMW: 15,
    sector: 'Private',
  },
  {
    id: 'dc-64',
    name: 'Foxconn Big Innovation Cloud AI factory',
    owner: 'Foxconn',
    country: 'Taiwan',
    lat: 23.6978,
    lon: 121.4605,
    status: 'planned',
    chipType: 'NVIDIA GB300 (Blackwell Ultra)',
    chipCount: 10000,
    powerMW: 26,
    sector: 'Private',
  },
  {
    id: 'dc-72',
    name: 'Imbue 10k Cluster',
    owner: 'Imbue',
    country: 'United States of America',
    lat: 42.6198,
    lon: -100.7798,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 10000,
    powerMW: 14.5,
    sector: 'Private',
  },
  {
    id: 'dc-73',
    name: 'Tesla 10k H100 Cluster',
    owner: 'Tesla',
    country: 'United States of America',
    lat: 29.3902,
    lon: -95.7129,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 10000,
    powerMW: 14.5,
    sector: 'Private',
  },
  {
    id: 'dc-75',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 34.9651,
    lon: 104.2738,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 10000,
    sector: 'Private',
  },
  {
    id: 'dc-123',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 37.5038,
    lon: 103.7554,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 10000,
    powerMW: 10,
    sector: 'Private',
  },
  {
    id: 'dc-132',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 36.7419,
    lon: 102.0705,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 10000,
    powerMW: 30,
    sector: 'Public',
  },
  {
    id: 'dc-134',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 38.4367,
    lon: 105.0073,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 10000,
    powerMW: 6,
    sector: 'Private',
  },
  {
    id: 'dc-136',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 35.1907,
    lon: 107.2219,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 10000,
    sector: 'Private',
  },
  {
    id: 'dc-211',
    name: 'Azure OpenAI GPT-3 Cluster',
    owner: 'Microsoft,OpenAI',
    country: 'United States of America',
    lat: 51.5485,
    lon: -88.1864,
    status: 'existing',
    chipType: 'NVIDIA V100',
    chipCount: 10000,
    powerMW: 6.6,
    sector: 'Private',
  },
  {
    id: 'dc-277',
    name: 'JAMSTEC ZettaScaler-2.2 Gyoukou',
    owner: 'Japan Agency for Marine-Earth Science and Technology',
    country: 'Japan',
    lat: 34.7548,
    lon: 135.7414,
    status: 'existing',
    chipType: 'PEZY-SC2',
    chipCount: 10000,
    powerMW: 2.6,
    sector: 'Public',
  },
  {
    id: 'dc-308',
    name: 'IndiaAI Mission Supercomputer',
    owner: 'Unknown',
    country: 'India',
    lat: 22.2358,
    lon: 78.5229,
    status: 'planned',
    chipType: 'Unknown',
    chipCount: 10000,
    sector: 'Public/Private',
  },
  {
    id: 'dc-310',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 41.8843,
    lon: 112.7965,
    status: 'planned',
    chipType: 'Unknown',
    chipCount: 10000,
    sector: 'Private',
  },
  {
    id: 'dc-214',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 38.6722,
    lon: 100.1816,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 9000,
    powerMW: 3,
    sector: 'Public',
  },
  {
    id: 'dc-77',
    name: 'S. Korea 6th national supercomputer',
    owner: 'Ministry of Science and ICT',
    country: 'Korea (Republic of)',
    lat: 36.3807,
    lon: 127.2508,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 8800,
    powerMW: 12.3,
    sector: 'Public',
  },
  {
    id: 'dc-178',
    name: 'Paper on AFM-server',
    owner: 'Google',
    country: 'United States of America',
    lat: 29.6217,
    lon: -107.436,
    status: 'existing',
    chipType: 'Google TPU v4',
    chipCount: 8192,
    powerMW: 5.7,
    sector: 'Private',
  },
  {
    id: 'dc-41',
    name: 'Nebius Kansas City Phase 2',
    owner: 'Nebius AI',
    country: 'United States of America',
    lat: 37.2603,
    lon: -99.6092,
    status: 'planned',
    chipType: 'NVIDIA B200',
    chipCount: 8000,
  },
  {
    id: 'dc-79',
    name: 'Nebius 8k Finland Phase 1',
    owner: 'Nebius AI',
    country: 'Finland',
    lat: 62.397,
    lon: 25.2321,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 8000,
    powerMW: 11.4,
    sector: 'Private',
  },
  {
    id: 'dc-80',
    name: 'Magic G4 Google Cloud Rental',
    owner: 'Google',
    country: 'United States of America',
    lat: 42.9147,
    lon: -90.3757,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 8000,
    powerMW: 11.2,
    sector: 'Private',
  },
  {
    id: 'dc-82',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 35.636,
    lon: 102.9151,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 8000,
    powerMW: 10,
    sector: 'Private',
  },
  {
    id: 'dc-142',
    name: 'Meta Research SuperCluster 2 (RSC-2)',
    owner: 'Meta AI',
    country: 'United States of America',
    lat: 37.5918,
    lon: -84.2238,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 8000,
    powerMW: 6.6,
    sector: 'Private',
  },
  {
    id: 'dc-225',
    name: 'Saudi Aramco Dammam-7',
    owner: 'Saudi Aramco',
    country: 'Saudi Arabia',
    lat: 23.6602,
    lon: 43.7989,
    status: 'existing',
    chipType: 'NVIDIA Tesla V100 SXM2',
    chipCount: 7912,
    powerMW: 5.1,
    sector: 'Private',
  },
  {
    id: 'dc-145',
    name: 'Tesla A100 Cluster Phase 2',
    owner: 'Tesla',
    country: 'United States of America',
    lat: 44.6108,
    lon: -104.6756,
    status: 'existing',
    chipType: 'NVIDIA A100 SXM4 80 GB',
    chipCount: 7360,
    powerMW: 6.3,
    sector: 'Private',
  },
  {
    id: 'dc-226',
    name: 'Eni HPC5',
    owner: 'Eni',
    country: 'Italy',
    lat: 42.7446,
    lon: 13.237,
    status: 'existing',
    chipType: 'NVIDIA V100',
    chipCount: 7280,
    powerMW: 4,
    sector: 'Private',
  },
  {
    id: 'dc-135',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 34.4117,
    lon: 101.6839,
    status: 'planned',
    chipType: 'Unknown',
    chipCount: 7000,
    powerMW: 8,
    sector: 'Public/Private',
  },
  {
    id: 'dc-202',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 36.4752,
    lon: 108.8552,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 7000,
    powerMW: 4,
    sector: 'Public',
  },
  {
    id: 'dc-302',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 44.6386,
    lon: 107.8309,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 7000,
    powerMW: 8,
    sector: 'Public',
  },
  {
    id: 'dc-309',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 25.8059,
    lon: 101.9661,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 7000,
    sector: 'Private',
  },
  {
    id: 'dc-86',
    name: 'Microsoft Sweden Staffanstorp',
    owner: 'Microsoft',
    country: 'Sweden',
    lat: 60.1282,
    lon: 19.1435,
    status: 'planned',
    chipType: 'Unknown',
    chipCount: 6666,
    sector: 'Private',
  },
  {
    id: 'dc-87',
    name: 'Microsoft Sweden Sandviken',
    owner: 'Microsoft',
    country: 'Sweden',
    lat: 60.6011,
    lon: 18.1274,
    status: 'planned',
    chipType: 'Unknown',
    chipCount: 6666,
    sector: 'Private',
  },
  {
    id: 'dc-88',
    name: 'Microsoft Sweden Gävle',
    owner: 'Microsoft',
    country: 'Sweden',
    lat: 59.2316,
    lon: 18.7219,
    status: 'planned',
    chipType: 'Unknown',
    chipCount: 6666,
    sector: 'Private',
  },
  {
    id: 'dc-89',
    name: 'Alps Supercomputer Phase 1',
    owner: 'ETH Domain',
    country: 'Switzerland',
    lat: 47.2911,
    lon: 7.7114,
    status: 'existing',
    chipType: 'NVIDIA GH200',
    chipCount: 6400,
    powerMW: 8.7,
    sector: 'Public',
  },
  {
    id: 'dc-147',
    name: 'Lawrence Berkeley NL NERSC Perlmutter',
    owner: 'US Department of Energy',
    country: 'United States of America',
    lat: 25.292,
    lon: -94.1596,
    status: 'existing',
    chipType: 'NVIDIA A100 SXM4 40 GB',
    chipCount: 6144,
    powerMW: 6.9,
    sector: 'Public',
  },
  {
    id: 'dc-203',
    name: 'Paper on PaLM',
    owner: 'Google',
    country: 'United States of America',
    lat: 24.7932,
    lon: -105.1487,
    status: 'existing',
    chipType: 'Google TPU v4',
    chipCount: 6144,
    powerMW: 4.4,
    sector: 'Private',
  },
  {
    id: 'dc-91',
    name: 'AIST ABCI 3.0',
    owner: 'National Institute of Advanced Industrial Science and Technology (AIST)',
    country: 'Japan',
    lat: 35.3082,
    lon: 138.3313,
    status: 'existing',
    chipType: 'NVIDIA H200 SXM',
    chipCount: 6128,
    powerMW: 8.6,
    sector: 'Public',
  },
  {
    id: 'dc-161',
    name: 'Meta Research SuperCluster (RSC-1) Phase 1',
    owner: 'Meta AI',
    country: 'United States of America',
    lat: 37.3607,
    lon: -78.7364,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 6080,
    powerMW: 5.2,
    sector: 'Private',
  },
  {
    id: 'dc-60',
    name: 'iGenius Colosseum',
    owner: 'iGenius',
    country: 'Italy',
    lat: 41.8719,
    lon: 13.0674,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 5760,
    powerMW: 13.8,
    sector: 'Private',
  },
  {
    id: 'dc-163',
    name: 'Tesla A100 Cluster Phase 1',
    owner: 'Tesla',
    country: 'United States of America',
    lat: 34.428,
    lon: -107.7213,
    status: 'existing',
    chipType: 'NVIDIA A100 SXM4 80 GB',
    chipCount: 5760,
    powerMW: 4.9,
    sector: 'Private',
  },
  {
    id: 'dc-287',
    name: 'CSCS Piz Daint Phase 2',
    owner: 'ETH Domain',
    country: 'Switzerland',
    lat: 45.9216,
    lon: 8.3059,
    status: 'existing',
    chipType: 'NVIDIA Tesla P100 PCIe 16GB',
    chipCount: 5704,
    powerMW: 4.4,
    sector: 'Public',
  },
  {
    id: 'dc-92',
    name: 'University of Bristol Isambard-AI',
    owner: 'UK Research and Innovation',
    country: 'United Kingdom of Great Britain and Northern Ireland',
    lat: 55.851,
    lon: -3.9521,
    status: 'existing',
    chipType: 'NVIDIA GH200',
    chipCount: 5448,
    powerMW: 7.6,
    sector: 'Public',
  },
  {
    id: 'dc-165',
    name: 'Microsoft Azure Meta AI Rental',
    owner: 'Microsoft',
    country: 'United States of America',
    lat: 30.8402,
    lon: -84.8876,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 5400,
    powerMW: 4.6,
    sector: 'Private',
  },
  {
    id: 'dc-240',
    name: 'NVIDIA SATURN V Phase 2',
    owner: 'NVIDIA',
    country: 'United States of America',
    lat: 54.8371,
    lon: -93.3765,
    status: 'existing',
    chipType: 'NVIDIA V100',
    chipCount: 5280,
  },
  {
    id: 'dc-65',
    name: 'Saudi Data & AI Authority Sovereign AI factory',
    owner: 'Saudi Data and Artificial Intelligence Authority',
    country: 'Saudi Arabia',
    lat: 23.8859,
    lon: 45.5792,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 5000,
    powerMW: 12,
    sector: 'Public',
  },
  {
    id: 'dc-95',
    name: 'Inflection-2 training cluster',
    owner: 'Inflection AI,CoreWeave',
    country: 'United States of America',
    lat: 32.0375,
    lon: -89.1281,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 5000,
  },
  {
    id: 'dc-96',
    name: 'Sustainable Metal Cloud Singapore Phase 2',
    owner: 'SMC - Sustainable Metal Cloud',
    country: 'Singapore',
    lat: 1.3521,
    lon: 104.3198,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 5000,
    powerMW: 7,
    sector: 'Private',
  },
  {
    id: 'dc-251',
    name: 'Paper on AlphaZero',
    owner: 'Google',
    country: 'United States of America',
    lat: 18.408,
    lon: -94.8972,
    status: 'existing',
    chipType: 'Google TPU v1',
    chipCount: 5000,
    powerMW: 0.9,
    sector: 'Private',
  },
  {
    id: 'dc-288',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 44.2326,
    lon: 102.7194,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 5000,
    powerMW: 1,
    sector: 'Private',
  },
  {
    id: 'dc-98',
    name: 'Nebius ISEG2',
    owner: 'Nebius AI',
    country: 'Iceland',
    lat: 64.9631,
    lon: -18.5208,
    status: 'existing',
    chipType: 'NVIDIA H200 SXM',
    chipCount: 4992,
    powerMW: 7,
    sector: 'Private',
  },
  {
    id: 'dc-67',
    name: 'Foxconn Hon Hai Kaohsiung Supercomputer',
    owner: 'Foxconn',
    country: 'Taiwan',
    lat: 24.1707,
    lon: 120.4444,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 4608,
    powerMW: 11.1,
    sector: 'Private',
  },
  {
    id: 'dc-99',
    name: 'NVIDIA Eos Phase 2',
    owner: 'NVIDIA',
    country: 'United States of America',
    lat: 45.4611,
    lon: -97.1889,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 4608,
    powerMW: 6.7,
    sector: 'Private',
  },
  {
    id: 'dc-100',
    name: 'Lawrence Livermore NL Tuolumne',
    owner: 'US Department of Energy',
    country: 'United States of America',
    lat: 37.9003,
    lon: -121.8409,
    status: 'existing',
    chipType: 'AMD Instinct MI300A',
    chipCount: 4608,
    powerMW: 5.7,
    sector: 'Public',
  },
  {
    id: 'dc-102',
    name: 'Mare Nostrum 5',
    owner: 'Barcelona Supercomputing Center,EuroHPC JU',
    country: 'Spain',
    lat: 40.4637,
    lon: -3.2492,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 4480,
    powerMW: 6,
    sector: 'Public',
  },
  {
    id: 'dc-171',
    name: 'NVIDIA Selene Phase 2',
    owner: 'NVIDIA',
    country: 'United States of America',
    lat: 36.9105,
    lon: -119.6209,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 4480,
    powerMW: 4.7,
    sector: 'Private',
  },
  {
    id: 'dc-103',
    name: 'Together AI H100 Cluster',
    owner: 'Together',
    country: 'United States of America',
    lat: 39.3937,
    lon: -87.1162,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 4424,
    powerMW: 6.4,
    sector: 'Private',
  },
  {
    id: 'dc-246',
    name: 'AIST ABCI 1.0',
    owner: 'National Institute of Advanced Industrial Science and Technology (AIST)',
    country: 'Japan',
    lat: 38.7798,
    lon: 139.0648,
    status: 'existing',
    chipType: 'NVIDIA Tesla V100 SXM2',
    chipCount: 4352,
    powerMW: 3,
    sector: 'Public',
  },
  {
    id: 'dc-234',
    name: 'Core42 AI-03',
    owner: 'G42',
    country: 'United Arab Emirates',
    lat: 22.6182,
    lon: 55.1129,
    status: 'existing',
    chipType: 'AMD Instinct MI210',
    chipCount: 4320,
    sector: 'Public/Private',
  },
  {
    id: 'dc-298',
    name: 'GSIC TSUBAME 2.5',
    owner: 'Tokyo Institute of Technology',
    country: 'Japan',
    lat: 36.3749,
    lon: 134.3566,
    status: 'existing',
    chipType: 'NVIDIA Tesla K20X',
    chipCount: 4224,
  },
  {
    id: 'dc-296',
    name: 'US Government Supercomputer 2',
    owner: 'United States Government',
    country: 'United States of America',
    lat: 27.532,
    lon: -114.074,
    status: 'existing',
    chipType: 'NVIDIA Tesla K40c',
    chipCount: 4160,
    powerMW: 2.9,
    sector: 'Public',
  },
  {
    id: 'dc-297',
    name: 'US Government Supercomputer 1',
    owner: 'United States Government',
    country: 'United States of America',
    lat: 31.6809,
    lon: -75.5251,
    status: 'existing',
    chipType: 'NVIDIA Tesla K40c',
    chipCount: 4160,
    powerMW: 2.9,
    sector: 'Public',
  },
  {
    id: 'dc-106',
    name: 'Yotta Shakti Cloud NM1 Phase 1',
    owner: 'Yotta Data Services',
    country: 'India',
    lat: 21.4664,
    lon: 79.6325,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 4096,
    powerMW: 5.8,
    sector: 'Private',
  },
  {
    id: 'dc-107',
    name: 'Sesterce Synapse Phase 2',
    owner: 'Sesterce',
    country: 'France',
    lat: 45.4217,
    lon: 3.4788,
    status: 'existing',
    chipType: 'NVIDIA H200 SXM',
    chipCount: 4096,
    powerMW: 5.7,
    sector: 'Private',
  },
  {
    id: 'dc-108',
    name: 'Sesterce H100s Phase 2',
    owner: 'Sesterce',
    country: 'France',
    lat: 47.8697,
    lon: 1.7737,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 4096,
    powerMW: 5.8,
    sector: 'Private',
  },
  {
    id: 'dc-215',
    name: 'Paper on Gemma 2 9B',
    owner: 'Google',
    country: 'United States of America',
    lat: 52.4068,
    lon: -102.8551,
    status: 'existing',
    chipType: 'Google TPU v4',
    chipCount: 4096,
    powerMW: 2.8,
    sector: 'Private',
  },
  {
    id: 'dc-216',
    name: 'Google TPU v4 Pod',
    owner: 'Google',
    country: 'United States of America',
    lat: 20.7816,
    lon: -100.855,
    status: 'existing',
    chipType: 'Google TPU v4',
    chipCount: 4096,
    powerMW: 3,
    sector: 'Private',
  },
  {
    id: 'dc-248',
    name: 'Google MLPerf 0.7 Submission',
    owner: 'Google',
    country: 'United States of America',
    lat: 36.292,
    lon: -77.4303,
    status: 'existing',
    chipType: 'Google TPU v3',
    chipCount: 4096,
    powerMW: 4,
    sector: 'Private',
  },
  {
    id: 'dc-249',
    name: 'Paper on Gopher',
    owner: 'Google DeepMind',
    country: 'United States of America',
    lat: 50.1717,
    lon: -108.7944,
    status: 'existing',
    chipType: 'Google TPU v3',
    chipCount: 4096,
    powerMW: 4,
    sector: 'Private',
  },
  {
    id: 'dc-271',
    name: 'Google TensorFlow Research Cloud',
    owner: 'Google',
    country: 'United States of America',
    lat: 45.5848,
    lon: -113.9297,
    status: 'existing',
    chipType: 'Google TPU v2',
    chipCount: 4096,
    powerMW: 2.7,
    sector: 'Private',
  },
  {
    id: 'dc-109',
    name: 'PanaAI AUS AISF',
    owner: 'PanaAI',
    country: 'Australia',
    lat: -25.2744,
    lon: 134.2751,
    status: 'planned',
    chipType: 'NVIDIA H200 SXM',
    chipCount: 4088,
    powerMW: 5.7,
    sector: 'Private',
  },
  {
    id: 'dc-110',
    name: 'Voltage Park Virginia',
    owner: 'Voltage Park',
    country: 'United States of America',
    lat: 37.5728,
    lon: -78.637,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 4088,
    powerMW: 5.7,
    sector: 'Private',
  },
  {
    id: 'dc-111',
    name: 'Voltage Park Location 6',
    owner: 'Voltage Park',
    country: 'United States of America',
    lat: 28.3511,
    lon: -92.5321,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 4088,
    powerMW: 5.7,
    sector: 'Private',
  },
  {
    id: 'dc-112',
    name: 'Voltage Park Texas Phase 2',
    owner: 'Voltage Park',
    country: 'United States of America',
    lat: 31.937,
    lon: -99.7168,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 4088,
    powerMW: 5.7,
    sector: 'Private',
  },
  {
    id: 'dc-113',
    name: 'Voltage Park Location 5',
    owner: 'Voltage Park',
    country: 'United States of America',
    lat: 45.8671,
    lon: -92.0774,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 4088,
    powerMW: 5.7,
    sector: 'Private',
  },
  {
    id: 'dc-114',
    name: 'Voltage Park Utah',
    owner: 'Voltage Park',
    country: 'United States of America',
    lat: 32.9908,
    lon: -104.5041,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 4088,
    powerMW: 5.7,
    sector: 'Private',
  },
  {
    id: 'dc-115',
    name: 'Voltage Park Washington',
    owner: 'Voltage Park',
    country: 'United States of America',
    lat: 47.5764,
    lon: -122.4976,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 4088,
    powerMW: 5.7,
    sector: 'Private',
  },
  {
    id: 'dc-116',
    name: 'ExxonMobil Discovery 6',
    owner: 'ExxonMobil',
    country: 'United States of America',
    lat: 34.1132,
    lon: -86.2711,
    status: 'existing',
    chipType: 'NVIDIA GH200',
    chipCount: 4032,
    powerMW: 5.7,
    sector: 'Private',
  },
  {
    id: 'dc-175',
    name: 'Tesla Training Cluster',
    owner: 'Tesla',
    country: 'United States of America',
    lat: 25.1156,
    lon: -89.4793,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 4032,
    powerMW: 3.5,
    sector: 'Private',
  },
  {
    id: 'dc-57',
    name: 'Sakura\'s B200s Phase 2',
    owner: 'Sakura Internet',
    country: 'Japan',
    lat: 36.2048,
    lon: 138.7529,
    status: 'planned',
    chipType: 'NVIDIA B200',
    chipCount: 4000,
  },
  {
    id: 'dc-76',
    name: 'SoftBank Planned B200 Superpod',
    owner: 'Softbank',
    country: 'Japan',
    lat: 36.6777,
    lon: 137.7368,
    status: 'planned',
    chipType: 'NVIDIA B200',
    chipCount: 4000,
    powerMW: 8,
    sector: 'Private',
  },
  {
    id: 'dc-117',
    name: 'Telangana Yotta H1 Hyderbad AI City Cluster Phase 1',
    owner: 'Government of Telangana',
    country: 'India',
    lat: 20.368,
    lon: 77.6826,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 4000,
    powerMW: 5.6,
    sector: 'Public',
  },
  {
    id: 'dc-118',
    name: 'OneAsia OBON Clusters',
    owner: 'OneAsia',
    country: 'Thailand',
    lat: 15.87,
    lon: 101.4925,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 4000,
    powerMW: 5.6,
    sector: 'Private',
  },
  {
    id: 'dc-119',
    name: 'CoreWeave LiquidLab',
    owner: 'CoreWeave',
    country: 'United States of America',
    lat: 45.8371,
    lon: -100.7629,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 4000,
    powerMW: 5.6,
    sector: 'Private',
  },
  {
    id: 'dc-120',
    name: 'Microsoft Azure ND H100 v5 VM',
    owner: 'Microsoft',
    country: 'United States of America',
    lat: 27.0344,
    lon: -97.9422,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 4000,
    powerMW: 5.8,
    sector: 'Private',
  },
  {
    id: 'dc-121',
    name: 'Sweden 4k H100 Cluster',
    owner: 'Unknown',
    country: 'Sweden',
    lat: 61.0009,
    lon: 19.3131,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 4000,
    powerMW: 5.6,
    sector: 'Private',
  },
  {
    id: 'dc-122',
    name: 'Nebius Kansas City Phase 1',
    owner: 'Nebius AI',
    country: 'United States of America',
    lat: 43.1128,
    lon: -87.1118,
    status: 'existing',
    chipType: 'NVIDIA H200 SXM',
    chipCount: 4000,
  },
  {
    id: 'dc-176',
    name: 'AWS EC2 P4d',
    owner: 'Amazon',
    country: 'United States of America',
    lat: 50.3234,
    lon: -92.1671,
    status: 'existing',
    chipType: 'NVIDIA A100 SXM4 40 GB',
    chipCount: 4000,
    powerMW: 3.5,
    sector: 'Private',
  },
  {
    id: 'dc-196',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 36.0318,
    lon: 100.2991,
    status: 'planned',
    chipType: 'Unknown',
    chipCount: 4000,
    powerMW: 3,
    sector: 'Public',
  },
  {
    id: 'dc-197',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 32.9626,
    lon: 107.0945,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 4000,
    powerMW: 3,
    sector: 'Public',
  },
  {
    id: 'dc-200',
    name: 'Intel Stability Gaudi 2',
    owner: 'Intel',
    country: 'United States of America',
    lat: 31.9453,
    lon: -100.0841,
    status: 'existing',
    chipType: 'Intel Habana Gaudi2',
    chipCount: 4000,
    powerMW: 4.9,
    sector: 'Private',
  },
  {
    id: 'dc-289',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 28.5242,
    lon: 99.5209,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 4000,
    powerMW: 1,
    sector: 'Private',
  },
  {
    id: 'dc-250',
    name: 'Cineca Marconi-100',
    owner: 'Cineca',
    country: 'Italy',
    lat: 41.6462,
    lon: 11.2871,
    status: 'existing',
    chipType: 'NVIDIA V100',
    chipCount: 3952,
    powerMW: 2.6,
    sector: 'Public',
  },
  {
    id: 'dc-220',
    name: 'Paper on AlphaCode',
    owner: 'Google',
    country: 'United States of America',
    lat: 40.8779,
    lon: -112.7981,
    status: 'existing',
    chipType: 'Google TPU v4',
    chipCount: 3750,
    powerMW: 2.7,
    sector: 'Private',
  },
  {
    id: 'dc-177',
    name: 'JUWELS-Booster',
    owner: 'Julich Supercomputing Center',
    country: 'Germany',
    lat: 51.6386,
    lon: 9.9354,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 3744,
    powerMW: 3.2,
    sector: 'Public',
  },
  {
    id: 'dc-167',
    name: 'Jean Zay Supercomputer Phase 4',
    owner: 'GENCI',
    country: 'France',
    lat: 43.9618,
    lon: 3.2702,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 3704,
    powerMW: 2.4,
    sector: 'Public',
  },
  {
    id: 'dc-129',
    name: 'NFDG Andromeda Phase 2',
    owner: 'Nat Friedman and Daniel Gross',
    country: 'United States of America',
    lat: 37.5301,
    lon: -78.6313,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 3632,
    powerMW: 5.8,
    sector: 'Private',
  },
  {
    id: 'dc-130',
    name: 'NVIDIA Coreweave MLPerf v3.0 Submission 2023',
    owner: 'NVIDIA,CoreWeave,Inflection AI',
    country: 'United States of America',
    lat: 48.1796,
    lon: -95.2287,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 3584,
  },
  {
    id: 'dc-253',
    name: 'TotalEnergies Pangea III',
    owner: 'TotalEnergies',
    country: 'France',
    lat: 45.5566,
    lon: 5.2402,
    status: 'existing',
    chipType: 'NVIDIA V100',
    chipCount: 3384,
    powerMW: 2.5,
    sector: 'Private',
  },
  {
    id: 'dc-291',
    name: 'Eni HPC4 Phase 1',
    owner: 'Eni',
    country: 'Italy',
    lat: 43.514,
    lon: 12.1274,
    status: 'existing',
    chipType: 'NVIDIA P100',
    chipCount: 3170,
    powerMW: 2.5,
    sector: 'Private',
  },
  {
    id: 'dc-255',
    name: 'Lawrence Livermore NL Lassen Phase 2',
    owner: 'US Department of Energy',
    country: 'United States of America',
    lat: 37.9245,
    lon: -121.9071,
    status: 'existing',
    chipType: 'NVIDIA V100',
    chipCount: 3168,
    powerMW: 2.1,
    sector: 'Public',
  },
  {
    id: 'dc-266',
    name: 'Jean Zay Supercomputer Phase 3',
    owner: 'GENCI',
    country: 'France',
    lat: 42.7575,
    lon: 1.7569,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 3112,
    powerMW: 2.1,
    sector: 'Public',
  },
  {
    id: 'dc-292',
    name: 'CSCS Piz Daint Phase 1',
    owner: 'ETH Domain',
    country: 'Switzerland',
    lat: 47.6909,
    lon: 8.8971,
    status: 'existing',
    chipType: 'NVIDIA Tesla P100 PCIe 16GB',
    chipCount: 3040,
    powerMW: 1.8,
    sector: 'Public',
  },
  {
    id: 'dc-128',
    name: 'Vultr Chicago Cluster',
    owner: 'Vultr',
    country: 'United States of America',
    lat: 41.9262,
    lon: -87.5693,
    status: 'existing',
    chipType: 'AMD Instinct MI300X',
    chipCount: 3000,
    powerMW: 4.6,
    sector: 'Private',
  },
  {
    id: 'dc-131',
    name: 'FPT AI Factory Japan',
    owner: 'FPT Corporation',
    country: 'Japan',
    lat: 35.9791,
    lon: 136.9726,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 3000,
    powerMW: 4.2,
    sector: 'Private',
  },
  {
    id: 'dc-198',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 40.1576,
    lon: 104.0078,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 3000,
    powerMW: 0.7,
    sector: 'Public/Private',
  },
  {
    id: 'dc-219',
    name: 'Tesla Dojo 1 Phase 1',
    owner: 'Tesla',
    country: 'United States of America',
    lat: 36.8293,
    lon: -119.6607,
    status: 'planned',
    chipType: 'Tesla D1 Dojo',
    chipCount: 3000,
    powerMW: 2.4,
    sector: 'Private',
  },
  {
    id: 'dc-280',
    name: 'Eni HPC4 Phase 2',
    owner: 'Eni',
    country: 'Italy',
    lat: 41.066,
    lon: 13.8325,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 3000,
    powerMW: 2,
    sector: 'Private',
  },
  {
    id: 'dc-294',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 40.0636,
    lon: 96.1236,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 3000,
    powerMW: 1,
    sector: 'Public',
  },
  {
    id: 'dc-301',
    name: 'Eni HPC2',
    owner: 'Eni',
    country: 'Italy',
    lat: 40.1866,
    lon: 11.6901,
    status: 'existing',
    chipType: 'NVIDIA Tesla K20X',
    chipCount: 3000,
    powerMW: 1.4,
    sector: 'Private',
  },
  {
    id: 'dc-201',
    name: 'IBM Vela',
    owner: 'IBM',
    country: 'United States of America',
    lat: 52.332,
    lon: -97.0464,
    status: 'existing',
    chipType: 'NVIDIA A100 SXM4 80 GB',
    chipCount: 2880,
    powerMW: 2.5,
    sector: 'Private',
  },
  {
    id: 'dc-138',
    name: 'KAUST Shaheen-III',
    owner: 'King Abdullah University of Science and Technology (KAUST)',
    country: 'Saudi Arabia',
    lat: 22.9893,
    lon: 45.1576,
    status: 'planned',
    chipType: 'NVIDIA GH200',
    chipCount: 2816,
    powerMW: 5.3,
    sector: 'Public',
  },
  {
    id: 'dc-259',
    name: 'Lawrence Livermore NL Lassen Phase 1',
    owner: 'US Department of Energy',
    country: 'United States of America',
    lat: 37.7124,
    lon: -121.9483,
    status: 'existing',
    chipType: 'NVIDIA V100',
    chipCount: 2736,
    powerMW: 1.9,
    sector: 'Public',
  },
  {
    id: 'dc-260',
    name: 'Jean Zay Supercomputer Phase 2',
    owner: 'GENCI',
    country: 'France',
    lat: 48.9308,
    lon: 0.3209,
    status: 'existing',
    chipType: 'NVIDIA Tesla V100 SXM2',
    chipCount: 2696,
    powerMW: 1.8,
    sector: 'Public',
  },
  {
    id: 'dc-139',
    name: 'CEA EXA1-HE Phase 3',
    owner: 'French Alternative Energies and Atomic Energy Commission (CEA)',
    country: 'France',
    lat: 44.5423,
    lon: 1.3364,
    status: 'existing',
    chipType: 'NVIDIA GH200',
    chipCount: 2688,
    powerMW: 3.8,
    sector: 'Public',
  },
  {
    id: 'dc-141',
    name: 'Los Alamos NL Venado',
    owner: 'US Department of Energy',
    country: 'United States of America',
    lat: 29.0999,
    lon: -103.7032,
    status: 'existing',
    chipType: 'NVIDIA GH200',
    chipCount: 2560,
    powerMW: 2.8,
    sector: 'Public',
  },
  {
    id: 'dc-143',
    name: 'NFDG Andromeda Phase 1',
    owner: 'Nat Friedman and Daniel Gross',
    country: 'United States of America',
    lat: 37.575,
    lon: -78.4795,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 2512,
    powerMW: 3.6,
    sector: 'Private',
  },
  {
    id: 'dc-144',
    name: 'Samsung SSC4',
    owner: 'Samsung',
    country: 'Korea (Republic of)',
    lat: 35.0112,
    lon: 127.8453,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 2496,
    powerMW: 3.5,
    sector: 'Private',
  },
  {
    id: 'dc-205',
    name: 'NVIDIA Selene Phase 1',
    owner: 'NVIDIA',
    country: 'United States of America',
    lat: 36.5998,
    lon: -119.6604,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 2240,
    powerMW: 2.4,
    sector: 'Private',
  },
  {
    id: 'dc-206',
    name: 'NAVER Corp Sejong',
    owner: 'NAVER',
    country: 'Korea (Republic of)',
    lat: 35.1019,
    lon: 129.032,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 2240,
    powerMW: 1.9,
    sector: 'Private',
  },
  {
    id: 'dc-207',
    name: 'Argonne NL Polaris',
    owner: 'US Department of Energy',
    country: 'United States of America',
    lat: 45.6333,
    lon: -109.1228,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 2240,
    powerMW: 1.9,
    sector: 'Public',
  },
  {
    id: 'dc-265',
    name: 'Petrobras Dragão',
    owner: 'Petrobras',
    country: 'Brazil',
    lat: -13.7621,
    lon: -52.4414,
    status: 'existing',
    chipType: 'NVIDIA V100',
    chipCount: 2176,
    powerMW: 1.7,
    sector: 'Public/Private',
  },
  {
    id: 'dc-293',
    name: 'GSIC TSUBAME 3.0',
    owner: 'Tokyo Institute of Technology',
    country: 'Japan',
    lat: 32.7347,
    lon: 137.7961,
    status: 'existing',
    chipType: 'NVIDIA Tesla P100 SXM2',
    chipCount: 2156,
    powerMW: 1.5,
    sector: 'Public',
  },
  {
    id: 'dc-208',
    name: 'Microsoft Azure Voyager-EUS2',
    owner: 'Microsoft',
    country: 'United States of America',
    lat: 21.5388,
    lon: -91.5459,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 2112,
    powerMW: 1.8,
    sector: 'Private',
  },
  {
    id: 'dc-148',
    name: 'AIST ABCI-Q',
    owner: 'National Institute of Advanced Industrial Science and Technology (AIST)',
    country: 'Japan',
    lat: 35.3989,
    lon: 139.518,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 2048,
    powerMW: 2.9,
    sector: 'Public',
  },
  {
    id: 'dc-149',
    name: 'Northern Data Group Taiga Cloud NO1 Island 2',
    owner: 'Northern Data Group',
    country: 'Norway',
    lat: 60.9449,
    lon: 7.9528,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 2048,
    powerMW: 2.9,
    sector: 'Private',
  },
  {
    id: 'dc-150',
    name: 'Sesterce Synapse Phase 1',
    owner: 'Sesterce',
    country: 'France',
    lat: 46.9458,
    lon: 4.1871,
    status: 'existing',
    chipType: 'NVIDIA H200 SXM',
    chipCount: 2048,
    powerMW: 2.9,
    sector: 'Private',
  },
  {
    id: 'dc-151',
    name: 'NVIDIA Israel-1 Phase 2',
    owner: 'NVIDIA',
    country: 'Israel',
    lat: 31.0461,
    lon: 35.3516,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 2048,
    powerMW: 2.9,
    sector: 'Private',
  },
  {
    id: 'dc-152',
    name: 'Northern Data Group Taiga Cloud NO1 Island 1',
    owner: 'Northern Data Group',
    country: 'Norway',
    lat: 59.5754,
    lon: 8.5473,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 2048,
    powerMW: 2.9,
    sector: 'Private',
  },
  {
    id: 'dc-153',
    name: 'Northern Data Group Njored Taiga Cloud Island 5',
    owner: 'Northern Data Group',
    country: 'United Kingdom of Great Britain and Northern Ireland',
    lat: 54.4815,
    lon: -3.3576,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 2048,
    powerMW: 2.9,
    sector: 'Private',
  },
  {
    id: 'dc-154',
    name: 'Horizon Compute Baobab Phase 2',
    owner: 'Horizon Compute',
    country: 'United States of America',
    lat: 47.0019,
    lon: -88.7726,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 2048,
    powerMW: 2.9,
    sector: 'Private',
  },
  {
    id: 'dc-204',
    name: 'Microsoft Ares/Maia',
    owner: 'Microsoft',
    country: 'United States of America',
    lat: 39.8165,
    lon: -80.2514,
    status: 'existing',
    chipType: 'Maia 100 (M100)',
    chipCount: 2048,
    powerMW: 2.1,
    sector: 'Private',
  },
  {
    id: 'dc-209',
    name: 'Softbank SuperPOD',
    owner: 'Softbank',
    country: 'Japan',
    lat: 33.939,
    lon: 139.3094,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 2048,
    powerMW: 1.7,
    sector: 'Private',
  },
  {
    id: 'dc-245',
    name: 'Paper on CoCa',
    owner: 'Google',
    country: 'United States of America',
    lat: 25.4557,
    lon: -109.5783,
    status: 'existing',
    chipType: 'Google TPU v4',
    chipCount: 2048,
    powerMW: 1.5,
    sector: 'Private',
  },
  {
    id: 'dc-267',
    name: 'AWS Fast BERT Training',
    owner: 'Amazon',
    country: 'United States of America',
    lat: 43.0742,
    lon: -76.7339,
    status: 'existing',
    chipType: 'NVIDIA V100',
    chipCount: 2048,
    powerMW: 1.4,
    sector: 'Private',
  },
  {
    id: 'dc-155',
    name: 'SoftBank CHIE-2',
    owner: 'Softbank',
    country: 'Japan',
    lat: 37.8469,
    lon: 137.8129,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 2040,
    powerMW: 2.9,
    sector: 'Private',
  },
  {
    id: 'dc-156',
    name: 'SoftBank CHIE-3',
    owner: 'Softbank',
    country: 'Japan',
    lat: 34.5195,
    lon: 137.3756,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 2040,
    powerMW: 2.9,
    sector: 'Private',
  },
  {
    id: 'dc-157',
    name: 'Sakura\'s H100s Phase 1',
    owner: 'Sakura Internet',
    country: 'Japan',
    lat: 36.923,
    lon: 140.2263,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 2016,
    powerMW: 2.9,
    sector: 'Public/Private',
  },
  {
    id: 'dc-210',
    name: 'Petrobras Pegasus (Pégaso)',
    owner: 'Petrobras',
    country: 'Brazil',
    lat: -14.235,
    lon: -51.4253,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 2016,
    powerMW: 1.8,
    sector: 'Public/Private',
  },
  {
    id: 'dc-268',
    name: 'Taiwania 2',
    owner: 'National Applied Research Laboratories Taiwan',
    country: 'Taiwan',
    lat: 24.5705,
    lon: 121.6301,
    status: 'existing',
    chipType: 'NVIDIA Tesla V100 SXM2',
    chipCount: 2016,
    powerMW: 1.5,
    sector: 'Public',
  },
  {
    id: 'dc-93',
    name: 'KDDI Sharp Sakai',
    owner: 'KDDI',
    country: 'Japan',
    lat: 37.0775,
    lon: 138.9225,
    status: 'planned',
    chipType: 'NVIDIA GB200',
    chipCount: 2000,
    powerMW: 4.8,
    sector: 'Private',
  },
  {
    id: 'dc-158',
    name: 'Quebec 2k H100 Cluster',
    owner: 'Unknown',
    country: 'Canada',
    lat: 56.1304,
    lon: -105.8468,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 2000,
    powerMW: 2.8,
    sector: 'Private',
  },
  {
    id: 'dc-159',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 32.3916,
    lon: 103.7386,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 2000,
    powerMW: 3,
    sector: 'Private',
  },
  {
    id: 'dc-160',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 38.24,
    lon: 107.0298,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 2000,
    powerMW: 3,
    sector: 'Private',
  },
  {
    id: 'dc-212',
    name: 'ND A100 v4',
    owner: 'Microsoft',
    country: 'United States of America',
    lat: 31.4469,
    lon: -111.2178,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 2000,
  },
  {
    id: 'dc-213',
    name: 'ExxonMobil Discovery 5',
    owner: 'ExxonMobil',
    country: 'United States of America',
    lat: 30.6994,
    lon: -80.2841,
    status: 'existing',
    chipType: 'NVIDIA A100 SXM4 40 GB',
    chipCount: 2000,
    powerMW: 1.7,
    sector: 'Private',
  },
  {
    id: 'dc-222',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 30.8826,
    lon: 105.2992,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 2000,
    powerMW: 1,
    sector: 'Private',
  },
  {
    id: 'dc-223',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 40.4516,
    lon: 106.8454,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 2000,
    powerMW: 0.3,
    sector: 'Public',
  },
  {
    id: 'dc-231',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 33.4528,
    lon: 109.3614,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 2000,
    powerMW: 1,
    sector: 'Public/Private',
  },
  {
    id: 'dc-244',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 37.544,
    lon: 97.9169,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 2000,
    powerMW: 1,
  },
  {
    id: 'dc-269',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 35.2255,
    lon: 111.4676,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 2000,
    powerMW: 1,
    sector: 'Private',
  },
  {
    id: 'dc-300',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 27.1226,
    lon: 107.3762,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 2000,
    powerMW: 1,
    sector: 'Public',
  },
  {
    id: 'dc-304',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 31.7623,
    lon: 95.4042,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 2000,
    powerMW: 2,
    sector: 'Public',
  },
  {
    id: 'dc-307',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 44.6086,
    lon: 99.1454,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 2000,
    sector: 'Public/Private',
  },
  {
    id: 'dc-235',
    name: 'Microsoft Explorer-WUS3',
    owner: 'Microsoft',
    country: 'United States of America',
    lat: 33.1864,
    lon: -112.1398,
    status: 'existing',
    chipType: 'AMD Radeon Instinct MI250X',
    chipCount: 1920,
    powerMW: 2,
    sector: 'Private',
  },
  {
    id: 'dc-162',
    name: 'CEA EXA1-HE Phase 2',
    owner: 'French Alternative Energies and Atomic Energy Commission (CEA)',
    country: 'France',
    lat: 47.1078,
    lon: 0.0888,
    status: 'existing',
    chipType: 'NVIDIA GH200',
    chipCount: 1908,
    powerMW: 2,
    sector: 'Public',
  },
  {
    id: 'dc-217',
    name: 'Samsung SSC-21',
    owner: 'Samsung',
    country: 'Korea (Republic of)',
    lat: 37.5499,
    lon: 127.3269,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 1760,
    powerMW: 1.5,
    sector: 'Private',
  },
  {
    id: 'dc-218',
    name: 'Tesla Auto-Labeling Cluster',
    owner: 'Tesla',
    country: 'United States of America',
    lat: 45.7402,
    lon: -80.7307,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 1752,
    powerMW: 1.5,
    sector: 'Private',
  },
  {
    id: 'dc-299',
    name: 'Energy Company DD',
    owner: 'Unknown',
    country: 'United States of America',
    lat: 54.8858,
    lon: -107.0499,
    status: 'existing',
    chipType: 'NVIDIA Tesla K80',
    chipCount: 1728,
    powerMW: 1.2,
    sector: 'Private',
  },
  {
    id: 'dc-295',
    name: 'JAMSTEC ZettaScaler-2.0 Gyoukou',
    owner: 'Japan Agency for Marine-Earth Science and Technology',
    country: 'Japan',
    lat: 38.5831,
    lon: 141.0873,
    status: 'existing',
    chipType: 'PEZY-SC2',
    chipCount: 1600,
    powerMW: 0.3,
    sector: 'Public',
  },
  {
    id: 'dc-221',
    name: 'Yandex Chervonenkis',
    owner: 'Yandex',
    country: 'Russia',
    lat: 55.7558,
    lon: 38.1173,
    status: 'existing',
    chipType: 'NVIDIA A100 SXM4 80 GB',
    chipCount: 1592,
    powerMW: 1.4,
    sector: 'Private',
  },
  {
    id: 'dc-254',
    name: 'Paper on Flamingo',
    owner: 'Google',
    country: 'United States of America',
    lat: 51.5684,
    lon: -83.5642,
    status: 'existing',
    chipType: 'Google TPU v4',
    chipCount: 1536,
    powerMW: 1.1,
    sector: 'Private',
  },
  {
    id: 'dc-168',
    name: 'Nebius ISEG',
    owner: 'Nebius AI',
    country: 'Finland',
    lat: 62.7968,
    lon: 26.4178,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1520,
    powerMW: 2.2,
    sector: 'Private',
  },
  {
    id: 'dc-169',
    name: 'Sandia NL El Dorado',
    owner: 'US Department of Energy',
    country: 'United States of America',
    lat: 25.3988,
    lon: -101.1647,
    status: 'existing',
    chipType: 'AMD Instinct MI300A',
    chipCount: 1520,
    powerMW: 1.9,
    sector: 'Public',
  },
  {
    id: 'dc-270',
    name: 'RPI AiMOS',
    owner: 'Rensselaer Polytechnic Institute',
    country: 'United States of America',
    lat: 40.5234,
    lon: -74.0366,
    status: 'existing',
    chipType: 'NVIDIA V100',
    chipCount: 1512,
    powerMW: 0.9,
    sector: 'Public',
  },
  {
    id: 'dc-303',
    name: 'Moscow State University Lomonosov 2',
    owner: 'Moscow State Univeristy',
    country: 'Russia',
    lat: 55.5301,
    lon: 36.337,
    status: 'existing',
    chipType: 'NVIDIA Tesla K40m',
    chipCount: 1472,
    powerMW: 0.9,
    sector: 'Public',
  },
  {
    id: 'dc-247',
    name: 'GENCI Adastra',
    owner: 'GENCI',
    country: 'France',
    lat: 44.7776,
    lon: -0.2978,
    status: 'existing',
    chipType: 'AMD Radeon Instinct MI250X',
    chipCount: 1352,
    powerMW: 1.6,
    sector: 'Public',
  },
  {
    id: 'dc-227',
    name: 'Microsoft Azure Pioneer-WUS2',
    owner: 'Microsoft',
    country: 'United States of America',
    lat: 47.6314,
    lon: -122.5574,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 1312,
    powerMW: 1.1,
    sector: 'Private',
  },
  {
    id: 'dc-228',
    name: 'Microsoft Azure Pioneer-WEU',
    owner: 'Microsoft',
    country: 'Netherlands',
    lat: 52.1326,
    lon: 5.7913,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 1312,
    powerMW: 1.1,
    sector: 'Private',
  },
  {
    id: 'dc-229',
    name: 'Microsoft Azure Pioneer-EUS',
    owner: 'Microsoft',
    country: 'United States of America',
    lat: 37.4165,
    lon: -78.7928,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 1312,
    powerMW: 1.1,
    sector: 'Private',
  },
  {
    id: 'dc-230',
    name: 'Microsoft Azure Pioneer-SCUS',
    owner: 'Microsoft',
    country: 'United States of America',
    lat: 31.8383,
    lon: -99.7318,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 1312,
    powerMW: 1.1,
    sector: 'Private',
  },
  {
    id: 'dc-276',
    name: 'G42 Artemis',
    owner: 'G42',
    country: 'United Arab Emirates',
    lat: 25.0662,
    lon: 53.4078,
    status: 'existing',
    chipType: 'NVIDIA V100',
    chipCount: 1296,
    powerMW: 1.2,
    sector: 'Public/Private',
  },
  {
    id: 'dc-174',
    name: 'Core42 SuperPOD',
    owner: 'G42',
    country: 'United Arab Emirates',
    lat: 23.1984,
    lon: 52.5675,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1272,
    powerMW: 1.8,
    sector: 'Public/Private',
  },
  {
    id: 'dc-279',
    name: 'Microsoft Azure Immunity Bio',
    owner: 'Microsoft',
    country: 'United States of America',
    lat: 18.3354,
    lon: -87.9444,
    status: 'existing',
    chipType: 'NVIDIA V100',
    chipCount: 1250,
    powerMW: 0.8,
    sector: 'Private',
  },
  {
    id: 'dc-252',
    name: 'KT Internal MI250 Cluster',
    owner: 'KT',
    country: 'Korea (Republic of)',
    lat: 33.642,
    lon: 128.8234,
    status: 'existing',
    chipType: 'AMD Radeon Instinct MI250X',
    chipCount: 1200,
    powerMW: 1.3,
    sector: 'Private',
  },
  {
    id: 'dc-281',
    name: 'SberCloud Christofari',
    owner: 'SberCloud',
    country: 'Russia',
    lat: 56.6285,
    lon: 38.2869,
    status: 'existing',
    chipType: 'NVIDIA V100',
    chipCount: 1200,
  },
  {
    id: 'dc-179',
    name: 'JCAHPC Miyabi',
    owner: 'Joint Center for Advanced High Performance Computing (JCAHPC)',
    country: 'Japan',
    lat: 37.085,
    lon: 136.128,
    status: 'existing',
    chipType: 'NVIDIA GH200',
    chipCount: 1120,
    powerMW: 1.6,
    sector: 'Public',
  },
  {
    id: 'dc-236',
    name: 'Naver DGX Superpod',
    owner: 'NAVER',
    country: 'Korea (Republic of)',
    lat: 34.2225,
    lon: 126.8896,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 1120,
    powerMW: 1,
    sector: 'Private',
  },
  {
    id: 'dc-237',
    name: 'University of Florida HiPerGator 3.0 Superpod',
    owner: 'University of Florida',
    country: 'United States of America',
    lat: 22.5912,
    lon: -85.5606,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 1120,
    powerMW: 1,
    sector: 'Public',
  },
  {
    id: 'dc-238',
    name: 'Yandex Lyapunov',
    owner: 'Yandex',
    country: 'Russia',
    lat: 56.2287,
    lon: 37.1012,
    status: 'existing',
    chipType: 'NVIDIA A100 SXM4 40 GB',
    chipCount: 1096,
    powerMW: 0.9,
    sector: 'Private',
  },
  {
    id: 'dc-239',
    name: 'Yandex Galushkin',
    owner: 'Yandex',
    country: 'Russia',
    lat: 54.8592,
    lon: 37.6957,
    status: 'existing',
    chipType: 'NVIDIA A100 SXM4 80 GB',
    chipCount: 1088,
    powerMW: 0.9,
    sector: 'Private',
  },
  {
    id: 'dc-282',
    name: 'Petrobras Atlas',
    owner: 'Petrobras',
    country: 'Brazil',
    lat: -15.1316,
    lon: -51.8469,
    status: 'existing',
    chipType: 'NVIDIA V100',
    chipCount: 1088,
    powerMW: 1,
    sector: 'Public/Private',
  },
  {
    id: 'dc-283',
    name: 'Japan Atomic Energy Agency and Quantum and Radiological Science and Technology HPE SGI8600',
    owner: 'Japan Atomic Energy Agency',
    country: 'Japan',
    lat: 35.5338,
    lon: 141.2794,
    status: 'existing',
    chipType: 'NVIDIA Tesla V100 SXM2',
    chipCount: 1088,
    powerMW: 0.7,
    sector: 'Public',
  },
  {
    id: 'dc-284',
    name: 'Jean Zay Supercomputer Phase 1',
    owner: 'GENCI',
    country: 'France',
    lat: 48.6059,
    lon: 5.0481,
    status: 'existing',
    chipType: 'NVIDIA Tesla V100 SXM2 32 GB',
    chipCount: 1044,
    powerMW: 0.7,
    sector: 'Public',
  },
  {
    id: 'dc-241',
    name: 'SK Telecom Titan Phase 2',
    owner: 'SK Telecom',
    country: 'Korea (Republic of)',
    lat: 36.626,
    lon: 129.7403,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 1040,
    powerMW: 0.9,
    sector: 'Private',
  },
  {
    id: 'dc-181',
    name: 'Ubilink.AI Supercomputer',
    owner: 'Ubilink AI',
    country: 'Taiwan',
    lat: 22.8012,
    lon: 121.0389,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1024,
    powerMW: 1.8,
    sector: 'Private',
  },
  {
    id: 'dc-182',
    name: 'LeptonAI H100 Cluster',
    owner: 'Lepton AI',
    country: 'United States of America',
    lat: 34.6418,
    lon: -81.8271,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1024,
    powerMW: 1.5,
    sector: 'Private',
  },
  {
    id: 'dc-183',
    name: 'IBM Blue Vela',
    owner: 'IBM',
    country: 'United States of America',
    lat: 48.4352,
    lon: -104.4182,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1024,
    powerMW: 1.5,
    sector: 'Private',
  },
  {
    id: 'dc-184',
    name: 'SIAM AI HGX',
    owner: 'SIAM AI',
    country: 'Thailand',
    lat: 16.3429,
    lon: 100.4764,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1024,
    powerMW: 1.5,
    sector: 'Private',
  },
  {
    id: 'dc-185',
    name: 'Horizon Compute Baobab Phase 1',
    owner: 'Horizon Compute',
    country: 'United States of America',
    lat: 22.6454,
    lon: -96.9767,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1024,
    powerMW: 1.5,
    sector: 'Private',
  },
  {
    id: 'dc-186',
    name: 'Chan Zuckerberg Initiative GPU Cluster',
    owner: 'CZ Biohub Network,CoreWeave',
    country: 'United States of America',
    lat: 47.0214,
    lon: -84.8749,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1024,
    powerMW: 1.4,
    sector: 'Public',
  },
  {
    id: 'dc-187',
    name: 'GreenNode Bangkok Cluster',
    owner: 'VNG Corporation',
    country: 'Thailand',
    lat: 14.9734,
    lon: 101.0709,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1024,
    powerMW: 1.5,
    sector: 'Private',
  },
  {
    id: 'dc-188',
    name: 'NVIDIA Eos Phase 1',
    owner: 'NVIDIA',
    country: 'United States of America',
    lat: 37.0902,
    lon: -110.6129,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1024,
  },
  {
    id: 'dc-189',
    name: 'Sustainable Metal Cloud Singapore Phase 1',
    owner: 'SMC - Sustainable Metal Cloud',
    country: 'Singapore',
    lat: 1.825,
    lon: 103.3037,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1024,
    powerMW: 1.5,
    sector: 'Private',
  },
  {
    id: 'dc-190',
    name: 'Denvr Dataworks H100',
    owner: 'Denvr Dataworks',
    country: 'United States of America',
    lat: 26.8888,
    lon: -84.58,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1024,
    powerMW: 1.5,
    sector: 'Private',
  },
  {
    id: 'dc-191',
    name: 'NVIDIA Israel-1 Phase 1',
    owner: 'NVIDIA',
    country: 'Israel',
    lat: 31.519,
    lon: 34.3355,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1024,
    powerMW: 1.5,
    sector: 'Private',
  },
  {
    id: 'dc-242',
    name: 'Paper on HyperCLOVA',
    owner: 'NAVER',
    country: 'Korea (Republic of)',
    lat: 36.788,
    lon: 125.642,
    status: 'existing',
    chipType: 'NVIDIA A100',
    chipCount: 1024,
    powerMW: 0.9,
    sector: 'Private',
  },
  {
    id: 'dc-261',
    name: 'Paper on GLaM',
    owner: 'Google',
    country: 'United States of America',
    lat: 34.5971,
    lon: -114.6495,
    status: 'existing',
    chipType: 'Google TPU v4',
    chipCount: 1024,
    powerMW: 0.7,
    sector: 'Private',
  },
  {
    id: 'dc-262',
    name: 'Paper on ViT-22B',
    owner: 'Google',
    country: 'United States of America',
    lat: 26.0202,
    lon: -79.9033,
    status: 'existing',
    chipType: 'Google TPU v4',
    chipCount: 1024,
    powerMW: 0.7,
    sector: 'Private',
  },
  {
    id: 'dc-263',
    name: 'Paper on PaLI',
    owner: 'Google',
    country: 'United States of America',
    lat: 56.128,
    lon: -99.9335,
    status: 'existing',
    chipType: 'Google TPU v4',
    chipCount: 1024,
    powerMW: 0.7,
    sector: 'Private',
  },
  {
    id: 'dc-264',
    name: 'Paper on Minerva',
    owner: 'Google',
    country: 'United States of America',
    lat: 20.0295,
    lon: -105.5629,
    status: 'existing',
    chipType: 'Google TPU v4',
    chipCount: 1024,
    powerMW: 0.7,
    sector: 'Private',
  },
  {
    id: 'dc-285',
    name: 'Preferred Networks MN-2',
    owner: 'Preferred Networks Inc',
    country: 'Japan',
    lat: 38.908,
    lon: 136.3601,
    status: 'existing',
    chipType: 'NVIDIA V100',
    chipCount: 1024,
    powerMW: 0.7,
    sector: 'Private',
  },
  {
    id: 'dc-286',
    name: 'Paper on RoBERTa',
    owner: 'Meta AI',
    country: 'United States of America',
    lat: 56.3539,
    lon: -88.7015,
    status: 'existing',
    chipType: 'NVIDIA Tesla V100 DGXS 32 GB',
    chipCount: 1024,
    powerMW: 0.6,
    sector: 'Private',
  },
  {
    id: 'dc-192',
    name: 'Scaleway Nabuchodonosor',
    owner: 'Iliad SA',
    country: 'France',
    lat: 48.8026,
    lon: 3.0256,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1016,
    powerMW: 1.5,
    sector: 'Private',
  },
  {
    id: 'dc-164',
    name: 'Gcore data center Phase 2',
    owner: 'Gcore,NHN Corporation',
    country: 'Korea (Republic of)',
    lat: 36.7805,
    lon: 128.4365,
    status: 'planned',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1000,
    powerMW: 1.9,
    sector: 'Private',
  },
  {
    id: 'dc-173',
    name: 'TensorWave MI300X Cluster 1 Phase 1',
    owner: 'TensorWave',
    country: 'United States of America',
    lat: 41.6391,
    lon: -108.2108,
    status: 'existing',
    chipType: 'AMD Instinct MI300X',
    chipCount: 1000,
    powerMW: 1.5,
    sector: 'Private',
  },
  {
    id: 'dc-193',
    name: 'Hut 8 H100 Cluster',
    owner: 'Hut 8',
    country: 'United States of America',
    lat: 41.6717,
    lon: -87.6422,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1000,
    powerMW: 1.4,
    sector: 'Private',
  },
  {
    id: 'dc-194',
    name: 'Voltage Park Texas Phase 1',
    owner: 'Voltage Park',
    country: 'United States of America',
    lat: 31.7805,
    lon: -100.1448,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1000,
    powerMW: 1.4,
    sector: 'Private',
  },
  {
    id: 'dc-195',
    name: 'NHN Cloud\'s National AI Data Center',
    owner: 'NHN Corporation',
    country: 'Korea (Republic of)',
    lat: 35.6821,
    lon: 126.4866,
    status: 'existing',
    chipType: 'NVIDIA H100 SXM5 80GB',
    chipCount: 1000,
    powerMW: 1.5,
    sector: 'Public/Private',
  },
  {
    id: 'dc-233',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 30.1296,
    lon: 102.1091,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 1000,
    powerMW: 1,
  },
  {
    id: 'dc-256',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 30.211,
    lon: 107.7953,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 1000,
    powerMW: 0.5,
    sector: 'Private',
  },
  {
    id: 'dc-257',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 42.6569,
    lon: 105.3936,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 1000,
    powerMW: 0.6,
    sector: 'Public/Private',
  },
  {
    id: 'dc-258',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 31.5395,
    lon: 98.5626,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 1000,
    powerMW: 0.6,
    sector: 'Public/Private',
  },
  {
    id: 'dc-273',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 28.1617,
    lon: 104.1954,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 1000,
    powerMW: 1,
    sector: 'Private',
  },
  {
    id: 'dc-274',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 41.6862,
    lon: 109.5326,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 1000,
    powerMW: 1,
    sector: 'Private',
  },
  {
    id: 'dc-275',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 35.1557,
    lon: 96.1262,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 1000,
    powerMW: 1,
    sector: 'Private',
  },
  {
    id: 'dc-278',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 30.809,
    lon: 110.7802,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 1000,
    powerMW: 0.8,
    sector: 'Private',
  },
  {
    id: 'dc-290',
    name: 'Anonymized Chinese System',
    owner: 'Unknown',
    country: 'China',
    lat: 38.1652,
    lon: 112.7921,
    status: 'existing',
    chipType: 'Unknown',
    chipCount: 1000,
    powerMW: 0.3,
    sector: 'Public',
  },
];
